import React, { useMemo } from "react";
import { css, useTheme } from "@emotion/react";
import ContentCombine from "core/Components/ContentCombine";

type Props = {
    description: string,
    isOutOfStock?: boolean,
    expectedDate?: string,
    isCentred?: boolean,
};

const Description: React.FC<Props> = (
    {
        description,
        isOutOfStock,
        expectedDate,
        isCentred = false,
    }
) => {
    const theme = useTheme();

    const outOfStockMsg = useMemo(() => {
        let msg = "Temporarily out of stock.";

        if (expectedDate) {
            const date = new Date(expectedDate).toLocaleString('en', { month: 'short', year: 'numeric' });
            msg += `\nNew stock expected ${date}.`;
        }

        return msg;
    }, [expectedDate]);

    const style = css`
        width: 90%;
        font-size: 18px;
        line-height: 26px;
        margin: 20px auto auto;

        ${isCentred && css`
            text-align: center;
        `}

        ${theme.breakpoints.down("xl")} {
            font-size: 16px;
            line-height: 23px;
        }
    `;

    const outOfStockStyle = css`
        position: relative;
        justify-content: center;
        text-align: center;
        font-size: 16px;
        height: 52px;
        line-height: 26px;
        margin-top: 7px;
        font-weight: ${theme.fonts.weights.bold};
        color: ${theme.colours.redOrange};

        ${theme.breakpoints.down("xl")} {
            font-size: 14px;
            line-height: 23px;
        }
    `;

    return (
        <>
            {isOutOfStock && (
                <ContentCombine css={outOfStockStyle}>{outOfStockMsg}</ContentCombine>
            )}

            <ContentCombine css={style} className={'product-description'}>{description}</ContentCombine>
        </>
    );
};

export default Description;
